import type { SVGProps } from 'react';

const Power = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.58232 4.58231C2.69478 6.46985 2.69478 9.53013 4.58232 11.4177C6.46985 13.3052 9.53013 13.3052 11.4177 11.4177C13.3052 9.53013 13.3052 6.46985 11.4177 4.58231"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 3.16666V7.49999"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Power;
